import { app, authentication } from "@microsoft/teams-js";

export function withTimeout<T>(promise: Promise<T>, timeoutMs: number, timeoutMessage: string): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timeoutId = window.setTimeout(() => {
      reject(new Error(timeoutMessage));
    }, timeoutMs);

    promise.then(
      (value) => {
        window.clearTimeout(timeoutId);
        resolve(value);
      },
      (error) => {
        window.clearTimeout(timeoutId);
        reject(error);
      }
    );
  });
}

export async function getTeamsSsoToken(): Promise<string> {
  await withTimeout(app.initialize(), 1500, "Timed out while initializing the Teams host.");
  return withTimeout(authentication.getAuthToken(), 15000, "Timed out while getting Teams SSO token.");
}

